import { render, staticRenderFns } from "./TeamFormUnder18.vue?vue&type=template&id=3418a532&scoped=true"
import script from "./TeamFormUnder18.vue?vue&type=script&lang=js"
export * from "./TeamFormUnder18.vue?vue&type=script&lang=js"
import style0 from "./TeamFormUnder18.vue?vue&type=style&index=0&id=3418a532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3418a532",
  null
  
)

export default component.exports